import React from 'react';
import PropTypes from 'prop-types';

class LoaderWithCircle extends React.PureComponent {

     render() {
          return <div className={`loader-with-circle ${this.props.className}`}>
               <div className="loader-with-circle_spinner" />
               <div className="loader-with-circle_inner-circle" />
          </div>;
     }
}

LoaderWithCircle.propTypes = {
};

export default LoaderWithCircle;